import { useCurrentEvent, usePicker } from '../components/CurrentEvent.js';
import { Icon } from '../components/Icon.js';
import { useOpen } from '../components/Shell.js';
import { HOME_TILES, NAV } from '../nav.js';
import { useSignedIn } from '../session.js';
import { HomeAtShow, ToDocumentCard, useTodo } from './events/HomeAtShow.js';

function greeting(hour: number): string {
  return hour < 12 ? 'Good morning' : hour < 18 ? 'Good afternoon' : 'Good evening';
}

/**
 * Home (brief section 5, docs/prototype.html): the day and the greeting,
 * then the home at a show when this device has a current event, else the
 * home at the office: the Office day card, the quick action tiles and To
 * document. The next trip card comes with Travel (step 9).
 */
export function Home() {
  const { user, can } = useSignedIn();
  const { eventId, event } = useCurrentEvent();
  const now = new Date();
  return (
    <>
      <p className="hello-date">
        {now.toLocaleDateString('en-CA', { weekday: 'long', month: 'long', day: 'numeric' })}
      </p>
      <h1 className="page">
        {greeting(now.getHours())}, {user.firstName}
      </h1>
      {eventId === undefined ? null : event && can('events.read') ? (
        <HomeAtShow event={event} />
      ) : (
        <AtTheOffice />
      )}
    </>
  );
}

function AtTheOffice() {
  const { can } = useSignedIn();
  const open = useOpen();
  const picker = usePicker();
  const todo = useTodo();
  return (
    <>
      <div className="home-top">
        <div className="event-card">
          <div>
            <span className="lbl">No event selected</span>
            <span className="ev">Office day</span>
          </div>
          {NAV.events.allowed(can) && (
            <div className="actions">
              <button type="button" className="btn sm" onClick={() => picker.show()}>
                Pick the current event
              </button>
              <button type="button" className="btn sm" onClick={() => open(NAV.events.path)}>
                Events
              </button>
            </div>
          )}
        </div>
        <div className="tiles" role="group" aria-label="Quick actions">
          {HOME_TILES.filter((key) => NAV[key].allowed(can)).map((key) => (
            <button
              key={key}
              type="button"
              className={`tilebtn${key === 'scan' ? ' red' : ''}`}
              onClick={() => open(NAV[key].path)}
            >
              <Icon name={NAV[key].icon} />
              <b>{key === 'scan' ? 'Scan card' : NAV[key].label}</b>
            </button>
          ))}
        </div>
      </div>
      <ToDocumentCard items={todo} office />
    </>
  );
}
